import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = ({ onServicesClick }: { onServicesClick?: () => void }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      window.location.hash = sectionId;
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="bg-white shadow-sm fixed w-full z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <button onClick={() => scrollToSection('hero')} className="flex items-center space-x-2 rtl:space-x-reverse">
            <img src="smc-logo.jpg" alt="SMC Logo" className="h-12" />
          </button>
          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-6 rtl:space-x-reverse">
            <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.home')}
            </button>
            <button onClick={() => { onServicesClick && onServicesClick(); scrollToSection('services'); }} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.gallery')}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('staff')} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.staff')}
            </button>
            <button onClick={() => scrollToSection('reviews')} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.reviews')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-primary-dark transition-colors">
              {t('nav.contact')}
            </button>
            <LanguageSwitcher />
          </div>
          <button 
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.home')}
              </button>
              <button 
                onClick={() => { onServicesClick && onServicesClick(); scrollToSection('services'); }}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.services')}
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.gallery')}
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.about')}
              </button>
              <button 
                onClick={() => scrollToSection('staff')}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.staff')}
              </button>
              <button 
                onClick={() => scrollToSection('reviews')}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.reviews')}
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-primary-dark transition-colors"
              >
                {t('nav.contact')}
              </button>
              <div className="pt-2">
                <LanguageSwitcher />
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 